import { Pipe, PipeTransform } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Pipe({
    name: 'isMobile',
    standalone: false
})
export class IsMobilePipe implements PipeTransform {
    transform(deviceService: DeviceDetectorService) {
        return deviceService.isMobile() || deviceService.isTablet();
    }
}
